// input-number.component.ts
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  standalone: false,
})
export class InputNumberComponent {
  @Input() id: string = '';
  @Input() placeholder: string = 'Entrer une valeur';
  @Input() min: number | undefined;
  @Input() max: number | undefined;
  @Input() value: number = 0;
  @Input() specialCase: boolean = false;
  @Input() maxLength: number | undefined;

  errors: string | undefined = undefined;

  @Output() valueChange = new EventEmitter<number>();

  validateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;

    // Vérifiez la longueur maximale
    if (this.maxLength !== undefined && inputValue.length > this.maxLength) {
      input.value = inputValue.slice(0, this.maxLength);
      this.value = this.max!;
      this.valueChange.emit(this.value);
      return;
    }

    const eventValue = parseFloat(inputValue);

    // Traitement des cas spéciaux
    if (this.specialCase) {
      if (this.min !== undefined && eventValue < this.min) {
        this.value = this.min;
      } else if (this.max !== undefined && eventValue > this.max) {
        this.value = this.max;
      } else {
        this.value = eventValue;
      }
      this.valueChange.emit(this.value);
      return;
    }

    // Traitement des valeurs dans la plage définie
    if (isNaN(eventValue)) {
      this.errors = 'La valeur doit être un nombre';
      this.value = 0;
    } else if (this.min !== undefined && eventValue < this.min) {
      this.errors = `La valeur doit être supérieure ou égale à ${this.min}`;
      this.value = this.min;
    } else if (this.max !== undefined && eventValue > this.max) {
      this.errors = `La valeur doit être inférieure ou égale à ${this.max}`;
      this.value = this.max;
    } else {
      this.errors = undefined;
      this.value = eventValue;
    }

    this.valueChange.emit(this.value);
  }
}
